import type { ComputedRef } from 'vue'

import { useKidRoutes } from '@entities/customer'
import { useDisciplineStore } from '@entities/customer'
import { trackEvent } from '@shared/lib/amplitude'

interface HeaderLogoReturn {
  homeUrl: ComputedRef<string>
  trackLogoClick: () => void
}

export const useHeaderLogo = (): HeaderLogoReturn => {
  const disciplineStore = useDisciplineStore()

  const {
    homeMath,
    homeEla,
  } = useKidRoutes()

  // A plain link: the app reloads on the active discipline's home, as the legacy logo buttons did.
  const homeUrl = computed(() => (disciplineStore.isEla ? homeEla.value : homeMath.value) || '/')

  const trackLogoClick = (): void => {
    trackEvent('Link_click', { feature: 'navigation', name: 'logo', url: homeUrl.value })
  }

  return {
    homeUrl,
    trackLogoClick,
  }
}
